import { useRef } from "react";
import StickerLabel from "@/components/stickers/StickerLabel";
import { SAMPLE, labelOrigin } from "@/lib/stickerDesign";

const PX = 96;

// Whole sheet with the scanned template behind it; drag the grid to line it up.
export default function SheetPreview({ design, setSheet, template, biz, logo }) {
  const { sheet } = design;
  const scale = 520 / (sheet.page_w * PX);
  const drag = useRef(null);
  const count = sheet.cols * sheet.rows;

  const down = (e) => { drag.current = { sx: e.clientX, sy: e.clientY, l: sheet.margin_left, t: sheet.margin_top }; e.currentTarget.setPointerCapture?.(e.pointerId); };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    setSheet({ ...sheet, margin_left: +(d.l + (e.clientX - d.sx) / (PX * scale)).toFixed(3), margin_top: +(d.t + (e.clientY - d.sy) / (PX * scale)).toFixed(3) });
  };
  const up = () => { drag.current = null; };

  return (
    <div className="rounded-lg border bg-neutral-200 p-4 overflow-auto" data-testid="sheet-preview">
      <div style={{ width: sheet.page_w * PX * scale, height: sheet.page_h * PX * scale }}>
        <div onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          style={{ position: "relative", width: `${sheet.page_w}in`, height: `${sheet.page_h}in`, background: "#fff", transform: `scale(${scale})`, transformOrigin: "top left", cursor: "grab", touchAction: "none" }}>
          {template && <img src={template} alt="" draggable={false} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "fill", opacity: design.template_opacity, pointerEvents: "none" }} />}
          {Array.from({ length: count }, (_, i) => {
            const o = labelOrigin(sheet, i);
            return (
              <div key={i} style={{ position: "absolute", left: `${o.left}in`, top: `${o.top}in`, outline: "1.5px solid rgba(16,185,129,.8)", pointerEvents: "none" }}>
                {i === 0 ? <StickerLabel sheet={sheet} elements={design.elements} decor={design.decor} data={SAMPLE} biz={biz} logo={logo} /> : <div style={{ width: `${sheet.label_w}in`, height: `${sheet.label_h}in` }} />}
              </div>
            );
          })}
        </div>
      </div>
      <p className="mt-2 text-xs text-neutral-600">Drag the green grid to line it up with your scanned sheet. Fine-tune with the numbers on the left.</p>
    </div>
  );
}
